module.exports = __webpack_public_path__ + "static/img/lixianrenwu2.82c6d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/lixianrenwu2.png
// module id = 744H
// module chunks = 24